module.exports = __webpack_public_path__ + "static/media/gr5-newsletter-2.3dffde0c.pdf";